import Vue from 'vue'
import config from '@/config/index'

const getDefaultState = () => {
  return {
    inited: false,
    settings: []
  }
}

const state = getDefaultState()

const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  inited (state, inited) {
    state.inited = inited
  },
  settings (state, settings) {
    state.settings = settings
  }
}

const actions = {
  reset ({ commit }) {
    commit('resetState')
  },
  loadSystemSettings ({ commit }, payload) {
    return Vue.axios.get(config.serverURI + '/systemSettings')
      .then((response) => {
        commit('settings', response.data)
        commit('inited', true)
        return Promise.resolve(response)
      }).catch((error) => {
        commit('inited', false)
        return Promise.reject(error)
      })
  }
}

const getters = {
  vat: state => {
    if (state.settings.find(x => x.id === 'vat.percentage')) {
      return state.settings.find(x => x.id === 'vat.percentage').value
    } else {
      return 0.0
    }
  },
  taxId: state => {
    if (state.settings.find(x => x.id === 'company.tax_id')) {
      return state.settings.find(x => x.id === 'company.tax_id').value
    } else {
      return ''
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/systemSetting.js